/**
 * @file   结缘古琴
 * @create lixiang 2025/05/12
 * @update
 */
import React from 'react';
import bg from '../../../assets/images/yzqf/jygqbg.jpg';

import { glpdata } from './data';
import Glpitem from './Glpitem';
function JYGQ({ setType }) {
  return (
    <div className="common-page animate__animated animate__fadeIn">
      <img src={bg} alt="" />
      <div className="jygqitembox">
        {glpdata.jygq.map((item, index) => {
          return <Glpitem item={item} index={index} key={index} />;
        })}
      </div>
      <div
        className="back"
        onClick={() => {
          setType('');
        }}></div>
    </div>
  );
}

export default JYGQ;
